import {
  init,
  createTracingMixins,
  attachErrorHandler,
  setContext,
  setUser,
  setTag,
  addBreadcrumb,
  captureException,
} from '@sentry/vue'
import posthog from 'posthog-js'

export default defineNuxtPlugin(({ vueApp, $config }) => {
  if (process.env.NODE_ENV === 'production') {
    init({
      app: [vueApp],
      dsn: $config.public.sentryDsn,
      debug: true,
      environment: process.env.NODE_ENV,
      tracesSampleRate: 0.7,
      integrations: [
        posthog.sentryIntegration({
          organization: 'zuno-carbon-rr',
          projectId: Number($config.public.sentryProjectId),
          severityAllowList: ['error', 'info'],
        }),
      ],
      beforeSend(event, hint) {
        // Check if it is an exception, and if so, log it.
        if (event.exception) {
          console.error(
            `[Exeption handled by Sentry]: (${hint.originalException})`,
            { event, hint },
          )
        }
        // Continue sending to Sentry
        return event
      },
    })

    vueApp.mixin(
      createTracingMixins({
        trackComponents: true,
        timeout: 2000,
        hooks: ['activate', 'mount', 'update'],
      }),
    )

    attachErrorHandler(vueApp, {
      logErrors: false,
      attachProps: true,
      trackComponents: true,
      timeout: 2000,
      hooks: ['activate', 'mount', 'update'],
    })

    return {
      provide: {
        sentrySetContext: setContext,
        sentrySetUser: setUser,
        sentrySetTag: setTag,
        sentryAddBreadcrumb: addBreadcrumb,
        sentryCaptureException: captureException,
        // In the code we can do something like

        // const { $sentryCaptureException } = useNuxtApp()

        // onMounted(() => {
        //   $sentryCaptureException("Test exception")
        // })
      },
    }
  }
})
